import { render, staticRenderFns } from "./BedAllocations.vue?vue&type=template&id=6f3dc7dc"
import script from "./BedAllocations.vue?vue&type=script&lang=js"
export * from "./BedAllocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports